"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileSellerAPIAdPriceRating = void 0;
var MobileSellerAPIAdPriceRating;
(function (MobileSellerAPIAdPriceRating) {
    MobileSellerAPIAdPriceRating["VERY_GOOD_PRICE"] = "VERY_GOOD_PRICE";
    MobileSellerAPIAdPriceRating["GOOD_PRICE"] = "GOOD_PRICE";
    MobileSellerAPIAdPriceRating["REASONABLE_PRICE"] = "REASONABLE_PRICE";
    MobileSellerAPIAdPriceRating["INCREASED_PRICE"] = "INCREASED_PRICE";
    MobileSellerAPIAdPriceRating["HIGH_PRICE"] = "HIGH_PRICE";
})(MobileSellerAPIAdPriceRating = exports.MobileSellerAPIAdPriceRating || (exports.MobileSellerAPIAdPriceRating = {}));
